import { plural } from "@helpers/format";

export const errorMessage = {
  required: "Обязательное поле",
  email: "Неправильный формат email",
  confirmPassword: "Пароли не совпадают",
  digitsAndWords: "Должен содержать буквы и цифры",
  min: (num: number) =>
    `Минимум ${num} ${plural(num, "символ", "символа", "символов")}`,
  max: (num: number) =>
    `Максимум ${num} ${plural(num, "символ", "символа", "символов")}`,
  onlyPositive: "Число должно быть положительным",
  maxSum: "На балансе недостаточно кол-во средств",
  onlyNumbers: "Разрешены только цифры",
  onlyCyrillicWithSpaces: "Разрешены только кириллические символы и пробелы",
  invalidPhoneNumber: "Неверный формат номера телефона",
  time: "Время должно быть в формате ЧЧ:ММ",
};
